import {
    CREATE_POST_REQUEST,
    CREATE_POST_SUCCESS,
    CREATE_POST_FAIL,
    ALL_POSTS_REQUEST,
    ALL_POSTS_SUCCESS,
    ALL_POSTS_FAIL,
    CHANGE_STATUS_REQUEST, 
    CHANGE_STATUS_SUCCESS,
     CHANGE_STATUS_FAIL,
     SAVED_POSTS_REQUEST,
     SAVED_POSTS_SUCCESS,
     SAVED_POSTS_FAIL,
     LIKED_POSTS_REQUEST,
     LIKED_POSTS_SUCCESS,
     LIKED_POSTS_FAIL,
    CLEAR_ERRORS,
    CREATE_YEARLY_PLAN_REQUEST,
    CREATE_YEARLY_PLAN_SUCCESS,
    CREATE_YEARLY_PLAN_FAIL,
    GET_YEARLY_PLAN_REQUEST,
    GET_YEARLY_PLAN_SUCCESS,
    GET_YEARLY_PLAN_FAIL,
    SAVED_PLANS_REQUEST,
    SAVED_PLANS_SUCCESS,
    SAVED_PLANS_FAIL
} from '../constants/postConstants';

//post reducer
export const postReducer = (state = { posts: [], totalPosts:0, totalPages:0}, action) => {
    switch(action.type){
        case ALL_POSTS_REQUEST:
            return{
                ...state,
                loading:true,
            }
        case ALL_POSTS_SUCCESS:
          var totalPages = Math.floor(action.payload.postCount / 12);
          if (action.payload.postCount % 12 !== 0) totalPages++;
          return {
            loading: false,
            posts: [...state.posts, ...action.payload.postToSend],                       // replace
            totalPosts: action.payload.postCount,
            totalPages: totalPages,
          };

        case ALL_POSTS_FAIL:
            return{
                loading: false,
                error: action.payload,
            }
            case CHANGE_STATUS_REQUEST:
            return{
                ...state,
                loading:true
            }
        case CHANGE_STATUS_SUCCESS:
           const updatedposts = state.posts.map((post) => {
                if(post._id.toString() === action.payload._id.toString()){
                    return action.payload;
                }
                return post;
            })
            return{
                loading: false,
                posts: updatedposts,
            }
        case CHANGE_STATUS_FAIL:
            return{
                loading:false,
                error: action.payload
            }
        case CLEAR_ERRORS:
            return{
                ...state,
                error:null,
            }
        default:
            return state;
    }
}


//new post reducer
export const newpostReducer = (state = { post: {} }, action) => {
    switch(action.type){
        case CREATE_POST_REQUEST:
            return {
                loading:true,
            };
        case CREATE_POST_SUCCESS:
            // console.log("post creation successful");
            return{
                ...state,
                loading:false,
                post: action.payload,
            };
        case CREATE_POST_FAIL:
            return{
                ...state,
                loading:false,
                error: action.payload,
            }
        case CLEAR_ERRORS:
                return {
                  ...state,
                  error: null,
                };
          
        default:
                return state;
            }
    }

export const savedPostsReducer = (state = { savedposts: [], postids: []}, action) => {
    switch(action.type){
        case SAVED_POSTS_REQUEST:
            return{
                loading:true,
                savedposts:[],
                postids:[]
            }
        case SAVED_POSTS_SUCCESS:
            // console.log("Savedpostlog", action.payload);
            return{
                ...state,
                loading:false,
                savedposts: action.payload,
                postids: action.payload.map(savedPost =>savedPost._id)
            }
        case SAVED_POSTS_FAIL:
            return{
                ...state,
                loading: false,
                error: action.payload,
            }
        case CLEAR_ERRORS:
            return{
                ...state,
                error:null,
            }
        default:
            return state;
    }
}
export const likedPostsReducer = (state = { likedposts: [], postids: []}, action) => {
    switch(action.type){
        case LIKED_POSTS_REQUEST:
            return{
                loading:true,
                likedposts:[],
                postids:[]
            }
        case LIKED_POSTS_SUCCESS:
            // console.log("Savedpostlog", action.payload);
            return{
                ...state,
                loading:false,
                likedposts: action.payload,
                postids: action.payload.map(likedPost =>likedPost._id)
            }
        case LIKED_POSTS_FAIL:
            return{
                ...state,
                loading: false,
                error: action.payload,
            }
        case CLEAR_ERRORS:
            return{
                ...state,
                error:null,
            }
        default:
            return state;
    }
}

export const yearlyPlanReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_YEARLY_PLAN_REQUEST:
            return {
                loading:true,
            };
    case CREATE_YEARLY_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        plan: action.payload
      };
    case GET_YEARLY_PLAN_REQUEST:
      return {
        ...state,
        loading: true
      };

    case GET_YEARLY_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        plan: action.payload
      };

    case "TOGGLE_PRIORITY_SUCCESS":
      if (!state.plan) return state;

      return {
        ...state,
        plan: {
          ...state.plan,
          posts: state.plan.posts.map((p) => {
            if (
              p.postId &&
              p.postId._id === action.payload.postId
            ) {
              return {
                ...p,
                postId: {
                  ...p.postId,
                  isPriority: action.payload.isPriority
                }
              };
            }
            return p;
          })
        }
      };

    case CREATE_YEARLY_PLAN_FAIL:
    case GET_YEARLY_PLAN_FAIL:
      return {
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};


export const myYearPlansReducer = (
  state = { plans: [] },
  action
) => {
  switch (action.type) {
    case "MY_YEAR_PLANS_REQUEST":
      return { loading: true, plans: [] };

    case "MY_YEAR_PLANS_SUCCESS":
      return { loading: false, plans: action.payload };

    case "MY_YEAR_PLANS_FAIL":
      return { loading: false, error: action.payload, plans: [] };

    default:
      return state;
  }
};

export const savedPlansReducer = (state = { loading: false, savedPlans: [] }, action) => {
  switch (action.type) {
    case SAVED_PLANS_REQUEST:
      return { loading: true, savedPlans: [] };
    case SAVED_PLANS_SUCCESS:
      return { loading: false, savedPlans: action.payload };
    case SAVED_PLANS_FAIL:
      return { loading: false, error: action.payload, savedPlans: [] };
    default:
      return state;
  }
};
